"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillMethodsProducts = exports.btnSummaryClick = exports.GetMethodsProducts = exports.checkboxProductChanged = exports.triggerProductOnchange = exports.btnProductClick = exports.onclickTdProduct = exports.onclickTdMethod = exports.MarkRestrictedMethods = exports.checkboxMethodChanged = exports.triggerMethodOnchange = exports.fillSummary = exports.InitMethods = exports.MethodsLoaded = exports.MethodsFavoritesLoaded = exports.$tableMethodsMicro = exports.$tableMethodsFavorites = exports.$tableMethods = void 0;
var Algemeen = require("../Algemeen");
var Aanvraag = require("../Aanvraag");
var SampleNature = require("../AanvraagAlgemeneInfo/SampleNature");
var SampleNature_1 = require("../AanvraagAlgemeneInfo/SampleNature");
var MethodProducts_1 = require("../Classes/MethodProducts");
var MethodsAll;
var MethodsFavoritesAll;
//var MethodsMicro: Method[];
var $divProductsTable;
var BtnProductsClassDisabled;
var ProductsFavoritesAll = new Array;
var templateMode;
var templateData;
var iSummaryRow;
var $tableProducts;
exports.MethodsFavoritesLoaded = false;
exports.MethodsLoaded = false;
//INIT
function InitMethods() {
    exports.$tableMethods = $('#tbodyMethods');
    exports.$tableMethodsFavorites = $('#tbodyMethodsFavorites');
    exports.$tableMethodsMicro = $('#tbodyMethodsMicro');
    BtnProductsClassDisabled = 'BtnProductsDisabled';
    CallWebServiceGetMethods();
    CallWebServiceGetMethodsFavorites();
    $("#dialogMethods").dialog({
        autoOpen: false,
        modal: true,
        width: 400,
        buttons: [
            {
                text: Algemeen.Translate('nmOk'),
                click: function () {
                    $(this).dialog("close");
                }
            }
        ]
    });
    $("#accordionMethods").accordion({
        active: 0,
        heightStyle: "content",
        collapsible: true
    });
    $("#dialogSummary").dialog({
        autoOpen: false,
        modal: false,
        width: 400,
        title: Algemeen.Translate('nmSamenvatting'),
        position: { my: "right top", at: "right top", of: "#accordionMethods" },
        close: function (event, ui) { $(".btnSummary").show(); },
        open: function (event, ui) { $(".btnSummary").hide(); }
    });
}
exports.InitMethods = InitMethods;
function fillSummary() {
    var $tableSummary = $('#tableSummary');
    $tableSummary.empty();
    iSummaryRow = 0;
    fillSummaryFromTable(exports.$tableMethodsFavorites, $tableSummary);
    fillSummaryFromTable(exports.$tableMethods, $tableSummary);
    fillSummaryFromTable(exports.$tableMethodsMicro, $tableSummary);
}
exports.fillSummary = fillSummary;
var errorRestrictedMethod = '';
function fillSummaryFromTable($table, $tableSummary) {
    $table.find('input[type="checkbox"]:checked.checkboxMethod').each(function () {
        var methodValue = $(this).val();
        var methodLocalValue = $(this).closest('.trMethod').find('.tdMethodLocalValue').html();
        var methodDescription = $(this).closest('.trMethod').find('.tdDescription').html();
        var $trMethod;
        if (!MethodIsRestrictedClient(methodValue)) {
            //if (!result) {
            $trMethod = $('<tr class="trSummaryMethod ' + Algemeen.GetTrClass(iSummaryRow) + '"><td class="tdMethodValue">' + methodLocalValue + '</td><td class="tdMethodDescription">' + methodDescription + '</td></tr>');
        }
        else {
            $trMethod = $('<tr class="trSummaryMethod ' + Algemeen.GetTrClass(iSummaryRow) + '"><td class="tdMethodValueRestricted">' + methodLocalValue + '</td><td class="tdMethodDescriptionRestricted">' + methodDescription + '</td></tr>');
        }
        $tableSummary.append($trMethod);
        $(this).closest('.trMethod').find('.divTableProducts').find('input[type="checkbox"]:checked').each(function () {
            var productValue = $(this).val();
            var productDescription = $(this).closest('.trProduct').find('.tdDescription').html();
            var $trProduct = $('<tr class="trSummaryProduct"><td class="tdSummaryProduct" colspan="2">' + productDescription + '</td></div>');
            $tableSummary.append($trProduct);
        });
        iSummaryRow += 1;
    });
    //});
}
var requestedMethodIsAllowed = true;
function MethodIsRestricted(methodCode) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestedMethodIsAllowed = true;
                    return [4 /*yield*/, Algemeen.CallWebServiceGetGenericDataSync('CheckMethodIsRestricted', "{method: '" + methodCode + "', sampleNature: '" + SampleNature.cbSampleNature.selectedValue.replace(/'/g, "\\'") + "'}")];
                case 1:
                    result = _a.sent();
                    requestedMethodIsAllowed = result.d;
                    return [2 /*return*/, requestedMethodIsAllowed];
            }
        });
    });
}
function MethodIsRestrictedClient(methodCode) {
    if (SampleNature_1.methodsRestricted !== undefined) {
        var method = SampleNature_1.methodsRestricted.find(function (f) { return f.code === methodCode; });
        if (method !== undefined)
            return method.restricted;
        else
            return false;
    }
    else
        return false;
}
function GetMethodTooltips(methodCode) {
    return __awaiter(this, void 0, void 0, function () {
        var methodTooltips, result, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    methodTooltips = '';
                    return [4 /*yield*/, Algemeen.CallWebServiceGetGenericDataSyncUsingGet('GetMethodTooltipInfo', "method=" + methodCode)];
                case 1:
                    result = _a.sent();
                    for (i = 0; i < result.length; i++) {
                        methodTooltips += result[i] + '<br />';
                    }
                    return [2 /*return*/, methodTooltips];
            }
        });
    });
}
//GET DATA METHODS
function CallWebServiceGetMethods() {
    Algemeen.CallWebServiceGetGeneric("GetMethods", OnSuccessGetMethods);
}
function OnSuccessGetMethods(data, status) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Algemeen.CheckSessionTimeout(data);
                    MethodsAll = data.d;
                    //MethodsMicro = MethodsAll.filter(f => f.ProjectCode != 'R');
                    //MethodsMicro.forEach(val => MethodsAll.splice(MethodsAll.indexOf(val), 1));
                    return [4 /*yield*/, fillListMethods(MethodsAll, exports.$tableMethods)];
                case 1:
                    //MethodsMicro = MethodsAll.filter(f => f.ProjectCode != 'R');
                    //MethodsMicro.forEach(val => MethodsAll.splice(MethodsAll.indexOf(val), 1));
                    _a.sent();
                    //await fillListMethods(MethodsMicro, $tableMethodsMicro);
                    exports.MethodsLoaded = true;
                    Aanvraag.CheckAllLoaded();
                    return [2 /*return*/];
            }
        });
    });
}
function CallWebServiceGetMethodsFavorites() {
    Algemeen.CallWebServiceGetGeneric("GetMethodsFavorites", OnSuccessGetMethodsFavorites);
}
function OnSuccessGetMethodsFavorites(data, status) {
    Algemeen.CheckSessionTimeout(data);
    MethodsFavoritesAll = data.d;
    if (MethodsFavoritesAll.length == 0) {
        $("#accordionMethods").accordion("option", "active", 1);
    }
    fillListMethods(data.d, exports.$tableMethodsFavorites);
    exports.MethodsFavoritesLoaded = true;
    Aanvraag.CheckAllLoaded();
}
//GET DATA PRODUCTS
function CallWebServiceGetProducts(Method) {
    Algemeen.CallWebServiceGetGenericData("GetProductsFavorites", "{'Method':'" + Method + "'}", OnSuccessGetProductsFavorites);
}
function OnSuccessGetProductsFavorites(data, status) {
    Algemeen.CheckSessionTimeout(data);
    ProductsFavoritesAll.push(data.d);
    Algemeen.CallWebServiceGetGenericData("GetProducts2", "{'Method':'" + data.d.Method + "'}", OnSuccessGetProducts);
}
function OnSuccessGetProducts(data, status) {
    Algemeen.CheckSessionTimeout(data);
    var Products = data.d;
    for (var i = 0; i < ProductsFavoritesAll.length; i++) {
        if (ProductsFavoritesAll[i].Method == Products.Method) {
            fillListProducts(Products, ProductsFavoritesAll[i]);
        }
    }
    fillSummary();
}
//LIST METHODS
function fillListMethods(Methods, $table) {
    return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    $table.empty();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < Methods.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, AddMethod(Methods[i], i, $table)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function AddMethod(Method, i, $table) {
    return __awaiter(this, void 0, void 0, function () {
        var trSingleProductMethod, MethodSelected, BtnClass, tdEvents, tdCheckbox, sMethodInfo, tdMethod, tooltipMethod, slurryText, tdDescription, tdProducts, tdTableProducts, tdProductsResult, tr, $tr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trSingleProductMethod = '';
                    if (Method.SingleProductMethod) {
                        trSingleProductMethod = 'trSingleProductMethod';
                    }
                    MethodSelected = '';
                    BtnClass = BtnProductsClassDisabled;
                    if (Aanvraag.EditMode) {
                        if (MethodChecked(Method.Method)) {
                            MethodSelected = 'checked';
                            BtnClass = '';
                        }
                    }
                    tdEvents = 'onclick="EntryPoint.onclickTdMethod(this);EntryPoint.triggerMethodOnchange(this);"';
                    tdCheckbox = '<td><input type="checkbox" class="checkboxMethod" value="' + Method.Method + '" onchange="EntryPoint.checkboxMethodChanged($(this));" ' + MethodSelected + '></input></td>';
                    sMethodInfo = '';
                    return [4 /*yield*/, GetMethodTooltips(Method.Method)];
                case 1:
                    sMethodInfo = _a.sent();
                    tdMethod = '<td style="display:none;" ' + tdEvents + '>' + Method.Method + '</td><td class="tdMethodLocalValue" ' + tdEvents + '>' + Method.LocalMethod + '</td>';
                    tooltipMethod = '<img id="ctl00_cphBody_Tooltip_' + Method.Method.replace(/ /g, "_") + '" style="border-width: 0px;" src="images/Information-icon.png" onmouseover="EntryPoint.showPopUp(this.id,\'' + sMethodInfo + '\', event)" onmouseleave="EntryPoint.hidePopUp(this.id, event)">';
                    if (sMethodInfo.length == 0) {
                        tooltipMethod = '';
                    }
                    slurryText = '';
                    if (Method.SlurryPossible)
                        slurryText = '<i class="fas fa-water" id="ctl00_cphBody_Slurry_' + Method.Method.replace(/ /g, "_") + '"  onmouseover="EntryPoint.showPopUp(this.id,\'' + Algemeen.Translate('nmSlurryAvailable') + '\', event)" onmouseleave="EntryPoint.hidePopUp(this.id, event)"></i>';
                    tdDescription = '<td ' + tdEvents + ' class="tdDescription"><table width="100%"><tr><td>' + Method.LocalDescription + '</td><td style="text-align:right" width="40px">' + slurryText + tooltipMethod + '</td></tr></table></td>';
                    if (SampleNature.cbSampleNature.selectedValue.length > 0) {
                        if (MethodIsRestrictedClient(Method.Method)) {
                            //if (result) {
                            tdMethod = '<td ' + tdEvents + 'class="tdMethodValueRestricted">' + Method.Method + '</td>';
                            tdDescription = '<td ' + tdEvents + ' class="tdMethodValueRestricted">' + Method.LocalDescription + '</td>';
                            //}
                        }
                    }
                    tdProducts = '<td class="tdProducts tdDefaultBackgroundColor"><button type="button" class="' + BtnClass + ' BtnProducts" value="' + Method.Method + '" onclick="EntryPoint.btnProductClick(this);">' + Algemeen.Translate('nmProduct') + '</button><div id="divProducts' + i + '" class="divProducts"></div></td>';
                    tdTableProducts = '<td class="tdTableProducts tdDefaultBackgroundColor"><div class="divTableProductsContainer"><div class="divTableProducts"></div></div></td>';
                    tdProductsResult = '<td class="tdProductsResult tdDefaultBackgroundColor"></td>';
                    tr = '<tr class="' + Algemeen.GetTrClass(i) + ' trItem trMethod ' + trSingleProductMethod + '">' + tdCheckbox + tdMethod + tdDescription + tdProducts + tdTableProducts + tdProductsResult + '</tr>';
                    $tr = $(tr);
                    $table.append($tr);
                    if (MethodSelected == 'checked') {
                        CallWebServiceGetProducts(Method.Method);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function triggerMethodOnchange(td) {
    var $checkbox = $(td.parentNode).find('.checkboxMethod');
    checkboxMethodChanged($checkbox);
}
exports.triggerMethodOnchange = triggerMethodOnchange;
function checkboxMethodChanged($checkbox) {
    var $row = $checkbox.closest('.trMethod');
    var $button = $row.find('button');
    if ($checkbox.is(':checked')) {
        if (MethodIsRestrictedClient($checkbox[0].value)) {
            errorRestrictedMethod = $checkbox[0].value + ' ' + $row[0].cells[2].innerText;
            Algemeen.CallWebServiceGetGenericDataSync('GetText', "{textCode: 'E-RESTRICTION'}").then(function (gettext) {
                var eRestrictionText = gettext.d.replace('@1@', '<br />' + errorRestrictedMethod + '<br />');
                Aanvraag.$dialogSaveResult.html(eRestrictionText);
                Aanvraag.$dialogSaveResult.dialog("open");
                Aanvraag.SetRequestedMethodsAllowed(false);
            });
        }
        $button.removeClass(BtnProductsClassDisabled);
        $tableProducts = $row.find('.tableProducts');
        if ($tableProducts.length) {
            fillTdProductsResult($tableProducts);
        }
        if (RowHasSingleProductMethod($row)) {
            btnProductClick($button[0]);
        }
        CheckProductsSelected($row);
    }
    else {
        $button.addClass(BtnProductsClassDisabled);
        var tdProductsResult = $row.find('.tdProductsResult');
        tdProductsResult.html('');
        $row.find('.tdProducts').removeClass('tdProductsInError');
    }
    fillSummary();
}
exports.checkboxMethodChanged = checkboxMethodChanged;
function MarkRestrictedMethods(tableName) {
    var table = document.getElementById(tableName);
    var _loop_1 = function () {
        var row = table.rows[i];
        MethodIsRestricted(row.cells[1].innerText).then(function (result) {
            var theMethod = {
                code: row.cells[1].innerText,
                restricted: result
            };
            SampleNature.methodsRestricted.push(theMethod);
            if (result) {
                row.cells[1].style.color = 'red';
                row.cells[2].style.color = 'red';
            }
            else {
                row.cells[1].style.color = 'black';
                row.cells[2].style.color = 'black';
            }
        });
    };
    for (var i = 1; i < table.rows.length; i++) {
        _loop_1();
    }
}
exports.MarkRestrictedMethods = MarkRestrictedMethods;
function SetCheckboxMethod($row, value) {
    $row.find('.checkboxMethod').prop('checked', value);
}
function RowHasSingleProductMethod($row) {
    return ($row.hasClass('trSingleProductMethod'));
}
function onclickTdMethod(td) {
    var $checkbox = $(td.parentNode).find('.checkboxMethod');
    $checkbox.prop('checked', !$checkbox.is(':checked'));
}
exports.onclickTdMethod = onclickTdMethod;
function onclickTdProduct(td) {
    var $checkbox = $(td.parentNode).find('.checkboxProduct');
    $checkbox.prop('checked', !$checkbox.is(':checked'));
}
exports.onclickTdProduct = onclickTdProduct;
function btnProductClick(btn) {
    if ($(btn).hasClass(BtnProductsClassDisabled)) {
        var td = btn.parentElement;
        onclickTdMethod(td);
        triggerMethodOnchange(td);
    }
    $divProductsTable = $(btn).closest('.trMethod').find('.divTableProducts');
    if ($divProductsTable.children().length == 0) {
        //        var $ProgressBar = $('<div id="progressbar"></div>');
        //        $ProgressBar.progressbar({ value: false });
        //        $divProductsTable.append($ProgressBar);
        CallWebServiceGetProducts(btn.value);
        //fillSummary()
    }
    ShowProductsTable();
}
exports.btnProductClick = btnProductClick;
function GetSelectedProducts(_MethodProducts, Products) {
    for (var i = 0; i < _MethodProducts.length; i++) {
        if (_MethodProducts[i].Code == Products.Method) {
            return _MethodProducts[i].Products;
        }
    }
}
function fillListProducts(Products, ProductsFavorites) {
    var $tbl = $(document.createElement("table"));
    $tbl.addClass("tableProducts");
    var SelectedProducts;
    if (Aanvraag.EditMode) {
        SelectedProducts = GetSelectedProducts(Aanvraag.AanvraagObj.MethodsProducts, Products);
    }
    if (templateMode) {
        SelectedProducts = GetSelectedProducts(templateData, Products);
    }
    var iRowColor = 0;
    for (var i = 0; i < ProductsFavorites.ProductList.length; i++) {
        AddProduct($tbl, ProductsFavorites.ProductList[i], SelectedProducts, 'trProductFavorite ' + Algemeen.GetTrClass(iRowColor));
        iRowColor += 1;
    }
    if (ProductsFavorites.ProductList.length > 0) {
        AddProductHR($tbl);
    }
    for (var i = 0; i < Products.ProductList.length; i++) {
        AddProduct($tbl, Products.ProductList[i], SelectedProducts, Algemeen.GetTrClass(iRowColor));
        iRowColor += 1;
    }
    SetDivProductsTableFromMethod(exports.$tableMethods, Products.Method);
    SetDivProductsTableFromMethod(exports.$tableMethodsFavorites, Products.Method);
    SetDivProductsTableFromMethod(exports.$tableMethodsMicro, Products.Method);
    $divProductsTable.empty();
    $divProductsTable.append($tbl);
    if (((Aanvraag.EditMode) || (templateMode)) && (SelectedProducts != undefined)) {
        if (SelectedProducts.length > 0) {
            fillTdProductsResult($tbl);
        }
    }
    CheckProductsSelected($divProductsTable.closest('.trMethod'));
    //if ((Aanvraag.EditMode) || (templateMode)) {
    //}
}
function SetDivProductsTableFromMethod($table, method) {
    $table.find('input[type="checkbox"]:checked.checkboxMethod').each(function () {
        if (this.value == method) {
            $divProductsTable = $(this).closest('.trMethod').find('.divTableProducts');
            return true;
        }
    });
}
function AddProduct(tableProducts, Product, SelectedProducts, trClass) {
    var ProductSelected = '';
    if (((Aanvraag.EditMode) || (templateMode)) && (SelectedProducts != undefined)) {
        if (ProductChecked(Product.Code, SelectedProducts)) {
            ProductSelected = 'checked';
        }
    }
    var tdEvents = 'onclick="EntryPoint.onclickTdProduct(this);EntryPoint.triggerProductOnchange(this);"';
    var tdCheckbox = '<td><input type="checkbox" class="checkboxProduct" value="' + Product.Code + '" onchange="EntryPoint.checkboxProductChanged(this);" ' + ProductSelected + '></input></td>';
    var tdProduct = '<td ' + tdEvents + ' class="tdDescription">' + Product.Description + '</td>';
    tableProducts.append('<tr class="trItem trProduct ' + trClass + '">' + tdCheckbox + tdProduct + '</tr>');
}
function AddProductHR(tableProducts) {
    var tdHR = '<td colspan="2"><hr /></td>';
    tableProducts.append('<tr class="trItem">' + tdHR + '</tr>');
}
function ProductChecked(productcode, SelectedProducts) {
    for (var i = 0; i < SelectedProducts.length; i++) {
        if (SelectedProducts[i] == productcode) {
            return true;
        }
    }
    return false;
}
function triggerProductOnchange(td) {
    var checkbox = td.parentNode.childNodes[0].firstElementChild;
    checkboxProductChanged(checkbox);
}
exports.triggerProductOnchange = triggerProductOnchange;
function ClickOutsideProduct() {
    $(document).mouseup(function (e) {
        if (!$divProductsTable.is(e.target) // if the target of the click isn't the container...
            && $divProductsTable.has(e.target).length === 0) // ... nor a descendant of the container
         {
            HideProductsTable();
        }
    });
}
function ShowProductsTable() {
    ClickOutsideProduct();
    $divProductsTable.show();
}
function HideProductsTable() {
    $divProductsTable.hide();
    //$(document).off("mouseup");
}
function checkboxProductChanged(checkbox) {
    var $tableProducts = $(checkbox).closest('.tableProducts');
    fillTdProductsResult($tableProducts);
    var $row = $divProductsTable.closest('tr');
    CheckProductsSelected($row);
    fillSummary();
}
exports.checkboxProductChanged = checkboxProductChanged;
function CheckProductsSelected($row) {
    if (RowHasSingleProductMethod($row)) {
        if (RowHasProductsSelected($row)) {
            $row.find('.tdProducts').removeClass('tdProductsInError');
        }
        else {
            $row.find('.tdProducts').addClass('tdProductsInError');
        }
    }
}
function fillTdProductsResult($tableProducts) {
    var $tdProductsResult = $tableProducts.closest('.trMethod').find('.tdProductsResult');
    var innerHTML = '';
    $tableProducts.find('input[type="checkbox"]:checked').each(function () {
        if (innerHTML != '') {
            innerHTML = innerHTML + ', ';
        }
        innerHTML = innerHTML + this.parentElement.parentElement.childNodes[1].innerHTML;
    });
    $tdProductsResult.html(innerHTML);
}
function RowHasProductsSelected($row) {
    $tableProducts = $row.find('.tableProducts');
    return ($tableProducts.find('input[type="checkbox"]:checked').length != 0);
}
//EVENTS
function GetMethodsProducts() {
    var MethodsProducts = [];
    $('#tableMethodsFavorites tr.trMethod').each(function (i, row) {
        GetMethodData($(row), MethodsProducts);
    });
    $('#tableMethods tr.trMethod').each(function (i, row) {
        GetMethodData($(row), MethodsProducts);
    });
    $('#tableMethodsMicro tr.trMethod').each(function (i, row) {
        GetMethodData($(row), MethodsProducts);
    });
    return MethodsProducts;
}
exports.GetMethodsProducts = GetMethodsProducts;
function GetMethodData($row, MethodsProducts) {
    var $checkbox = $row.find('input:checkbox.checkboxMethod');
    if ($checkbox.is(':checked')) {
        var ogMethod = MethodsAll.find(function (f) { return f.Method == $checkbox.val(); });
        //if (!ogMethod)
        //    ogMethod = MethodsMicro.find(f => f.Method == $checkbox.val());
        if (!ogMethod)
            ogMethod = MethodsFavoritesAll.find(function (f) { return f.Method == $checkbox.val(); });
        var _Method = new MethodProducts_1.MethodProducts();
        _Method.Code = ogMethod.Method;
        _Method.SlurryPossible = ogMethod.SlurryPossible;
        $row.find('.tableProducts tr.trProduct').each(function (i, rowProduct) {
            var $rowProduct = $(rowProduct);
            var $checkboxProduct = $rowProduct.find('input:checkbox');
            if ($checkboxProduct.is(':checked')) {
                _Method.Products.push($checkboxProduct.val());
            }
        });
        MethodsProducts.push(_Method);
    }
}
function btnSummaryClick() {
    $("#dialogSummary").dialog("open");
}
exports.btnSummaryClick = btnSummaryClick;
//function Method() {
//    this.Code = '';
//    this.Products = new Array();
//}
function MethodChecked(method) {
    for (var i = 0; i < Aanvraag.AanvraagObj.MethodsProducts.length; i++) {
        if (Aanvraag.AanvraagObj.MethodsProducts[i].Code == method) {
            return true;
        }
    }
    return false;
}
function fillMethodsProducts(_MethodsProducts) {
    templateMode = true;
    templateData = _MethodsProducts;
    fillMethodsProducts_Method(exports.$tableMethods);
    fillMethodsProducts_Method(exports.$tableMethodsFavorites);
    fillMethodsProducts_Method(exports.$tableMethodsMicro);
    setTimeout(function () { return fillSummary(); }, 0);
}
exports.fillMethodsProducts = fillMethodsProducts;
function fillMethodsProducts_Method($table) {
    $table.find('input[type="checkbox"].checkboxMethod').each(function () {
        var $checkbox = $(this);
        var methodValue = $checkbox.val();
        for (var i = 0; i < templateData.length; i++) {
            if (templateData[i].Code == methodValue) {
                $checkbox.prop('checked', true);
                var $row = $checkbox.closest('.trMethod');
                var $button = $row.find('button');
                $button.removeClass(BtnProductsClassDisabled);
                CallWebServiceGetProducts(methodValue);
                break;
            }
        }
    });
}
